var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-2"},[_c('v-col',{attrs:{"align":"left"}},[_c('cancel-order-dialog',{attrs:{"order":_vm.order}})],1),_c('v-col',{attrs:{"align":"right"}},[_c('deliver-order-dialog',{attrs:{"order":_vm.order}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }